import RadioListing from "../../RadioListing";
import { getLabel } from "../../../hooks/use-labels";
import ResizeWrapper from "../../../components/ResizeWrapper";

import CODImage from "../assets/cod.svg";

const CashOnDelivery = (props) => {
  const { methodDetails, onChange } = props;

  const onChangeOption = ({ target }) => {
    const codInfo = {
      codId: target.value,
      amount: props.amount,
      description: props.description,
    };

    onChange({ ...codInfo, method: "COD" });
  };

  return (
    <ResizeWrapper
      render={(resizeWidth) => (
        <div className="wallet-processor">
          <RadioListing
            options={[
              {
                label: getLabel("cashOnDeliveryLabel"),
                value: "cod",
                imgSrc: CODImage,
              },
            ]}
            className="payment-radio-listing"
            value={methodDetails.codId}
            onChange={onChangeOption}
            labelClass={`align-center ${
              resizeWidth > 375
                ? "font-18-regular-500-lh-22"
                : "font-14-bold-500-lh-20"
            }`}
          />
        </div>
      )}
    />
  );
};

export default CashOnDelivery;
